<template>
  <div style="height:100%" id="i18n" class="en">
    <!-- Dev小精灵提醒您：您的浏览器版本过低，推荐使用谷歌浏览器进行学习，点击下载  -->
    <div v-if="browserSupport == false" class="browser">

      <a
        target="_blank"
        href="https://www.google.cn/intl/zh-CN/chrome/"
      >{{$t('broswer1')}}</a>&nbsp;

      <i
        class="el-icon-close"
        style="cursor: pointer;margin-left:10px;font-size:16px;vertical-align: middle;"
        @click="noSign"
      ></i>
    </div>
    <div class="app11" id="box">
      <div class="topbar">
        <i @click="goHome"></i>

        <!-- <span>{{$t('nav_name')}}</span> -->
        <div class="mainBox1">
        <div class="changeLangBtn" @click.stop="moreLang()">
          <button class="text">
            {{ $t("language") }}
          </button>
          <em class="iconfont icon-een"></em>
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li
              v-for="(item, index) in langList"
              class="chooseLangUlli"
              :key="index"
              @click="setLanguage(item.id)"
            >
              <button class="text">
              {{ item.name }}
              </button>
            </li>
          </ul>
        </div>
        </div>
      </div>

      <!-- {{$t('homepage_button1')}}   {{$t('homepage_button2')}}-->
      <div class="banner">
        <div class="loginOrres">
          <button class="login" @click="login">{{$t('homepage_button1')}}</button>
          <button class="res" @click="resg">{{$t('homepage_button2')}}</button>
        </div>
      </div>
    </div>
    <div class="bgiOver" v-if="padWarnShow">
      <div class="over over1">
        <div class="timeout032" @click="getOut"></div>
      </div>
    </div>
  </div>
</template>

<script>

import store from "../store";
import { mapGetters } from "vuex";
import ChannelMedia from "@/utils/ChannelMedia";
import I18nUtils from "@/utils/i18nUtils";

export default {
  name: "join",
  data() {
    return {
      ua: "",
      browserType: "",
      browserVersion: 0,
      browserSupport: true,

      notChrome: false,
      loginShow: true,
      resShow: true,
      overShow: true,
      changeLangBox: false,
      langList: I18nUtils.langList,
      country: ""
    };
  },

  mounted() {
    // 初始化
    ChannelMedia.getInstance().initChannel(window.location.search);

    // 判断用户使用设备
    let os = (function() {

      let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
          /(?:iPad|PlayBook)/.test(ua) ||
          (isAndroid && !/(?:Mobile)/.test(ua)) ||
          (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
      };
    })();
    if (os.isAndroid || os.isPhone || os.isTablet) {
      store.state.padWarnShow = true;
    }

    this.checkBrowser();

    // 设置语言
    I18nUtils.initLanguage(this);

    // 查看是否已经登录
    this.getMsg();
  },
  watch: {},
  methods: {
    //   userMsg
    async getMsg() {
      try {
        let res = await this.$http.getAxios("/user/queryUserInfo");
        if (res.data.code == "0") {
          store.commit("toggleMaskState",false);
          this.$nextTick(() => {
            this.$router.push({ path: "/index" });
          });
        }
      } catch (err) {
        console.log("not logined");
      }
    },
    //  检测浏览器
    checkBrowser() {
      this.ua = navigator.userAgent;
      var ua = navigator.userAgent.toLocaleLowerCase();
      var tem; 
      var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if(/trident/i.test(M[1])){
          tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
          return 'IE '+(tem[1] || '');
      }
      if(M[1]=== 'Chrome'){
          tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
          if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
      if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);

      this.browserType = M[0];
      this.browserVersion = M[1];

      this.browserSupport = false
        || (this.browserType == 'chrome'  && this.browserVersion >= 51)
        || (this.browserType == 'firefox' && this.browserVersion >= 54)
        || (this.browserType == 'safari'  && this.browserVersion >= 10)
        || (this.browserType == 'opera'   && this.browserVersion >= 38)
    },

    getOut() {
      store.state.padWarnShow = false;
    },
    noSign() {
      this.notChrome = false;
    },

    login() {
      this.$router.push({ path: "/signIn" });
    },
    resg() {
      this.$router.push({ path: "/signUp" });
      // var url = process.env.GO_WEB;
      // window.location.href = url
    },
    goHome() {
      this.$router.push({ path: "/" });
    },
    moreLang() {
      this.changeLangBox = !this.changeLangBox;
    },

    setLanguage(lang) {
      I18nUtils.setLanguage(this, lang);
    },
  },
  computed: {
    ...mapGetters(["padWarnShow",'maskBox'])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only  -->
<style scoped rel="stylesheet/scss" lang="scss">
html,
body {
  height: 100%;
}

.browser {
  a {
    color: #333;
  }
  height: 50px;
  width: 100%;
  background: #fff;
  font-size: 16px;
  line-height: 50px;
  text-align: center;
  color: #3080ca;
}

.banner {
  width: 1200px;
  margin: 0 auto;
}
.topbar {
  width: 100%;
  height: 60px;
  color: #aaf9fe;
  background: #122346;
  i {
    position: absolute;
    top: 13px;
    left: 40px;
    width: 172px;
    height: 46px;
    cursor: pointer;
    z-index: 999999999;
    background: url("~@/assets/images/bigIcon.png") no-repeat center;
  }
}
.topbar span {
  font-size: 20px;
  line-height: 60px;
  margin-left: 100px;
}
.loginOrres {
  width: 700px;
  position: absolute;
  top: 60vh;
  left: 50%;
  transform: translateX(-50%);
}
.loginOrres .login {
  width: 320px;
  height: 140px;
  float: left;
  cursor: pointer;
  background: url("~@/assets/images/largeIcon.png") no-repeat center;
  text-align: center;
  line-height: 125px;
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  padding-bottom: 20px;
  border: none;
}

.loginOrres .res {
  width: 325px;
  height: 140px;
  float: right;
  cursor: pointer;
  background: url("~@/assets/images/largeIcon.png") no-repeat center;
  text-align: center;
  line-height: 125px;
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  padding-bottom: 20px;
  border: none;
}
.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  line-height: 60px;
}

.chooseLangUl {
  position: absolute;
  z-index: 111;
  li {
    height: 40px;
    cursor: pointer;
  }
}

.changeLangBtn {
  cursor: pointer;
  float: right;
  font-weight: normal;
  font-size: 18px;
  padding-right: 20px;
}
.mainBox1 {
  height: 60px;
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 323;
}

.over {
  width: 725px;
  height: 467px;
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
}

.over1 {
  width: 715px;
  height: 457px;
}
.bgiOver {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
}
.over {
  width: 420px;
  height: 340px;
  position: absolute;
  top: 20%;
  background: url("~@/assets/images/padWarn.png") no-repeat center;
  background-size: contain;
  left: 50%;
  transform: translateX(-50%);
}

.timeout032 {
  position: absolute;
  width: 120px;
  height: 61px;
  background: url("~@/assets/images/okok.png") no-repeat center;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
}

.app11 {
// 按钮切换
button:active{
    position: relative;
    top: 4px;
    box-shadow: inset 0 3px 5px 0 rgba(0,0,0,0.2);  
    outline: 0;
}
button:focus, button:hover {
  box-shadow: inset 0 -1px 0 0 #aaf9fe, 0 0 2px 0 cyan;
}

button.text {
  border: none;
  background: none;
  cursor: pointer;
  color: #aaf9fe;
  padding: 2px;
}

button.underline {
  text-decoration: underline;
}

}


// 多语言模块
.en, .he {
  .app11 { 
    background: url("~@/assets/images/homeEn.jpg") no-repeat center center; 
    background-size: cover;
    height: 100%;
    width: 100%;
    position: relative;
  }
}

.zh {
  .app11 { 
    background: url("~@/assets/images/homeZh.jpg") no-repeat center center; 
    background-size: cover;
    height: 100%;
    width: 100%;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/join.vue